import React, { useState, useEffect } from 'react';
import { injectStripe } from 'react-stripe-elements';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import { useSnackbar } from 'notistack';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import api from '../../utils/api';
import CardModal from './CardModal';
import { useModal } from '../../utils/modal';
import { confimStripeCard } from '../../store/actions/account';

function CreditCardForm({ stripe }) {
  const { t } = useTranslation(['account']);
  const [setupIntent, setSetupIntent] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const modal = useModal();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {}, []);

  const openIntent = async () => {
    try {
      const response = await api.user.createStripeSetupIntents();
      setSetupIntent(response.stripe_setup_intent);
      modal.open();
    } catch (error) {
      throw error;
    }
  };

  const confirmCard = async confirmMethod => {
    try {
      const response = await dispatch(
        confimStripeCard(setupIntent.id, confirmMethod.payment_method)
      );
      enqueueSnackbar(t('payment_method:add-payment-methods-success'), {
        variant: 'success'
      });
    } catch (error) {
      throw error;
    }
  };

  const onResult = result => {
    if (result.error && result.error.message) {
      enqueueSnackbar(result.error.message, { variant: 'error' });
    } else if (result && result.setupIntent) {
      confirmCard(result.setupIntent);
      modal.close();
    } else {
      enqueueSnackbar('error', { variant: 'error' });
    }
  };

  return (
    <div>
      <div className="about-button">
        <Button
          className="help-button"
          variant="contained"
          color="primary"
          onClick={openIntent}
        >
          {t('payment_method:add-payment-methods')}
        </Button>
      </div>

      <CardModal
        isModal={true}
        isMobile={isMobile}
        setupIntent={setupIntent}
        open={modal.isOpen}
        onClose={modal.close}
        onResult={onResult}
      />
    </div>
  );
}

export default injectStripe(CreditCardForm);
